import http from '../http';
import { PDISCHRAGES_API } from '@/config/env';

export const getPdischarge = (id: number) => http.get(`${PDISCHRAGES_API}/${id}`);

export const getPdischarges = () => http.get(`${PDISCHRAGES_API}`);

export const getPdischargesFullResponse = () =>
  http.get(`${PDISCHRAGES_API}`, { returnFullResponse: true });

export const createPdischarges = (pDischarges: any) => http.post(`${PDISCHRAGES_API}`, pDischarges);

export const createPdischargesFullResponse = (pDischarges: any) =>
  http.post(`${PDISCHRAGES_API}`, pDischarges, { returnFullResponse: true });

export const hasUsedDischarge = async (pDischargeId: number) => {
  return await http.get(`${PDISCHRAGES_API}/${pDischargeId}/in-use`);
};
